const certCentersRu = {
    hero: {
        partnerLabel: 'Сертификационным центрам',
        title: 'Превращайте запросы на сертификацию в заявки от импортеров',
        description: 'Подключитесь к Вэдмаркету и получайте клиентов, которые уже определили товар, код ТН ВЭД и формат подтверждающих документов',
    },
    comparison: {
        negativeList: [
            'Большая часть времени уходит на контакты с компаниями, которые находятся на ранней стадии и не готовы заказывать сертификацию в ближайшее время',
            'Клиенты без понимания требований, требуется долгий опрос — часто нет базовой информации о товаре, и работа заканчивается на этапе уточнений',
            'Без понимания кода ТН ВЭД, технической документации и нужного типа сертификата любой расчет носит приблизительный характер и создает риски ошибок и недопонимания',
        ],
        positiveList: [
            'Получайте заявки от компаний, где большая часть работы по сбору информации уже выполнена',
            'Импортер уже знает точное описание и характеристики товара — они загружены в систему',
            'Клиент готов обсудить детали, потому что уже заложил бюджет в свою финансовую модель',
        ],
        negativeResults: [
            {emoji: '😤', text: 'Опять "Спасибо, до свидания"'},
            {emoji: '😩', text: 'Я не знаю...'},
            {emoji: '🤯', text: 'Давайте вы сначала все уточните'},
        ],
        positiveResults: [
            {emoji: '🥳', text: 'Давно бы так!'},
            {emoji: '😎', text: 'Да, всё есть!'},
            {emoji: '🤩', text: 'Всё готово, вперёд!'},
        ],
    },
    steps: [
        {
            title: 'Вы настраиваете профиль за 30 минут',
            emoji: '🧮',
            description: 'Загружаете прайс-лист на услуги (сертификация, декларация, испытания), указываете специализацию (типы продукции и лабораторные возможности), задаете условия работы и дополнительные требования',
        },
        {
            title: 'Ваше предложение видят те, кому актуально',
            emoji: '📦',
            description: 'Импортер выбирает в калькуляторе товар и видит предварительный код ТН ВЭД, система автоматически определяет потребность в разрешительных документах и ему показываются профили центров (включая ваш), чья специализация и лабораторная база подходят под его товар',
        },
        {
            title: 'Вы получаете структурированную заявку',
            emoji: '📑',
            description: 'Клиент выбирает ваш центр и отправляет заявку, в которой уже есть: полное описание товара и его технические параметры; предварительный код ТН ВЭД; данные компании-импортера; загруженные документы; ориентир по бюджету на сертификацию',
        },
        {
            title: 'Ваши тарифы — часть итогового решения',
            emoji: '🧩',
            description: 'Ваши тарифы и условия работы интегрированы в платформу и отображаются клиенту на важном этапе формирования запроса',
        },
        {
            title: 'Вы контролируете поток',
            emoji: '👀',
            description: 'Настройте получение заявок только по нужным направлениям, типам груза и объемам',
        },
    ],
    benefits: {
        title: 'Почему сертификационные центры выбирают нас?',
        cards: [
            {
                title: 'Рост конверсии запросов в сделки',
                emoji: '👍🏻',
                text: 'Вы общаетесь только с квалифицированными клиентами на финальной стадии планирования импорта',
            },
            {
                title: 'Экономия времени менеджеров',
                emoji: '💪🏻',
                text: 'Сокращается объем первичных консультаций и уточнения информации',
            },
            {
                title: 'Точность расчетов и коммерческих предложений',
                emoji: '✍🏻',
                text: 'Вы видите код ТН ВЭД и описание товара до первого звонка — это минимизирует ошибки и риски',
            },
            {
                title: 'Снижение стоимости привлечения клиентов',
                emoji: '🤝🏻',
                text: 'Вы работаете с целевыми обращениями без необходимости инвестировать в холодный маркетинг и нецелевые каналы',
            },
        ],
    },
};

export default certCentersRu;
